import React from 'react'

import NavBar from '../navbar'
import Home from '../home'
import Footer from '../footer'

const Layout = () => (
  <div>
    <NavBar />
    <Home />
    <Footer />
  </div>
)

export default Layout
